import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChatflowScheduleRange, ChatflowScheduleRangeRequest } from '../models/chatflow-schedule.model';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatflowScheduleApiService {
  private readonly base = `${environment.apiUrl}api/chatflows`;

  constructor(private http: HttpClient) {}

  /** GET devuelve un ARRAY de rangos semanales (puede venir vacío). */
  getSchedule(chatflowId: number): Observable<ChatflowScheduleRange[]> {
    return this.http.get<ChatflowScheduleRange[]>(`${this.base}/${chatflowId}/schedule`);
  }

  /** PUT reemplaza TODOS los rangos del chatflow con la lista enviada. */
  updateSchedule(chatflowId: number, ranges: ChatflowScheduleRangeRequest[]): Observable<ChatflowScheduleRange[]> {
    return this.http.put<ChatflowScheduleRange[]>(`${this.base}/${chatflowId}/schedule`, ranges);
  }
}
